import { render, staticRenderFns } from "./message-details-design-block.vue?vue&type=template&id=716c65a4&scoped=true&"
import script from "./message-details-design-block.vue?vue&type=script&lang=js&"
export * from "./message-details-design-block.vue?vue&type=script&lang=js&"
import style0 from "./message-details-design-block.vue?vue&type=style&index=0&id=716c65a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716c65a4",
  null
  
)

export default component.exports